export default __webpack_public_path__ + "6963fd0b909bd379dc2b5fcf504e2f02.png";